import { orderConfirmationAccountSignUpMessageStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationAccountSignUpMessage";
import { css } from "styled-components";

orderConfirmationAccountSignUpMessageStyles.container = {
    ...orderConfirmationAccountSignUpMessageStyles.container,

    css: css`
        margin-bottom: 20px;
    `,
};
